import { jsx as _jsx } from "react/jsx-runtime";
import styles from './styles.module.scss';
import cx from 'clsx';
import { forwardRef } from 'react';
/**
 * Anchor styled as Clover button.
 * Supports all props that can be applied to a native HTML `a` element.
 *
 * MDN Anchor docs: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes
 */
/**
 * @title
 *  LinkButton
 * @label
 *  LinkButton
 * @shortdescription
 *  Anchor styled as Clover button.
 * @keywords
 *  [Anchor,Clover button,Link button]
 * @description
 * Anchor styled as Clover button. Note: Use sentence case for the label!
 * Supports all props that can be applied to a native HTML `a` element.
 * @componentUsage
 *
<LinkButton
    className="yourClass"
    destructive={boolean}
    type="button | submit"
    variant="primary | secondary | tertiary | link| (none)"
    fullwidth={boolean}
>
    Button text
</LinkButton>
 * @example
<LinkButton
    type="button"
    variant="tertiary"
    href="#"
>
    Link button
</LinkButton>
 */
export const LinkButton = forwardRef(({ variant = 'primary', fullwidth, large, className, children, ...passThroughProps }, ref) => {
    return (_jsx("a", { ref: ref, className: cx(styles.button, styles[variant], fullwidth && styles.fullwidth, large && styles.large, className), ...passThroughProps, children: children }));
});
LinkButton.displayName = 'LinkButton';
//# sourceMappingURL=LinkButton.js.map